// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bk5jTPd8bRkWk9lCcAQs{flex-direction:column;height:100%;padding:0 44px;display:flex;position:relative}.uavFPlvm2ZIySNV_CHLy{flex-direction:column;gap:16px;height:100%;padding:0 14px 0 15px;display:flex}.S81ajx1hdcHGNFJp0EHw{display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `bk5jTPd8bRkWk9lCcAQs`,
	"navBar": `uavFPlvm2ZIySNV_CHLy`,
	"navBarTabs": `S81ajx1hdcHGNFJp0EHw`
};
export default ___CSS_LOADER_EXPORT___;
